module.exports = __webpack_public_path__ + "img/platform_banner.7e1a3ab4.png";